import { Outlet } from "react-router-dom";
import NoAccess from "~/components/shared/no-access";
import { findRecordWithFullAccess } from "~/lib/utils";
import { useSelector } from "~/redux/store";

interface PermissionRouteProps {
  /** A PermissionKeys constant e.g. PermissionKeys.itemManagement.incidents.view */
  permissionKey: string;
}

/**
 * Route-level permission guard.
 *
 * Wrap any <Route> with this component to enforce a permission at the router
 * level, rather than relying on individual page components to remember to add
 * the <NoAccess /> check themselves.
 *
 * Usage in routes/index.tsx:
 *   <Route element={<PermissionRoute permissionKey={PermissionKeys.itemManagement.incidents.view} />}>
 *     <Route path="/incidents" element={<Incidents />} />
 *     <Route path="/incidents/:id" element={<IncidentDetail />} />
 *   </Route>
 */
export const PermissionRoute: React.FC<PermissionRouteProps> = ({
  permissionKey,
}) => {
  const permissions = useSelector(
    (state) => state.persistedReducer.auth.permissions,
  );

  if (!findRecordWithFullAccess(permissions, permissionKey)) {
    return <NoAccess />;
  }

  return <Outlet />;
};

export default PermissionRoute;
